import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import "animate.css";
import TrackVisibility from "react-on-screen";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import Spinner from "./Spinner";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { addDoc, collection, getDocs, query } from "firebase/firestore";
import { db } from "../firebase";

export const Contact = () => {
  const [myData, setMyData] = useState([]);
  async function fetchData() {
    try {
      const projectRef = collection(db, "profile");
      const q = query(projectRef);
      const querySnap = await getDocs(q);
      let projects = [];
      querySnap.forEach((doc) => {
        projects.push({
          id: doc.id,
          data: doc.data(),
        });
      });
      setMyData(projects);
      //console.log(projects);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    await addDoc(collection(db, "messages"), data);
    setLoading(false);

    setLoading(true);

    const templateParams = {
      name: data.name,
      phone: data.phone,
      email: data.email,
      message: data.message,
    };

    emailjs
      .send(
        process.env.REACT_APP_GMAIL_SERVICE_ID,
        process.env.REACT_APP_GMAIL_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_GMAIL_PROFILE_ID
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setLoading(false);
          toast.success("Message Sent");
          setData({ name: "", phone: "", email: "", message: "" });
        },
        (error) => {
          console.log("FAILED...", error);
          setLoading(false);
          toast.error("Message Send Failed");
        }
      );
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <section className="contact" id="connect">
      <div className="about-section" style={{ marginBottom: "30px" }}>
        <h1 className="background-text" >
          Contact
        </h1>
        <h1 className="foreground-text" style={{ color: "#A673D1",fontWeight:800 }}>
          Contact
          <div className="underline" style={{ backgroundColor: "white" }}></div>
        </h1>
      </div>
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                  style={{
                    textAlign: "center",
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          id="name"
                          value={data.name}
                          name="name"
                          placeholder="Name"
                          onChange={handleOnChange}
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="tel"
                          id="phone"
                          value={data.phone}
                          name="phone"
                          placeholder="Phone No."
                          onChange={handleOnChange}
                        />
                      </Col>
                      <Col size={12} sm={12} className="px-1">
                        <input
                          type="email"
                          id="email"
                          value={data.email}
                          name="email"
                          placeholder="Email Address"
                          onChange={handleOnChange}
                        />
                      </Col>
                      <Col size={12} className="px-1">
                        <textarea
                          rows="6"
                          id="message"
                          value={data.message}
                          name="message"
                          placeholder="Message"
                          onChange={handleOnChange}
                        ></textarea>
                        <button
                          type="submit"
                          style={{
                            marginBottom: window.innerWidth <= 768 ? "30px" : "0px",
                          }}
                        >
                          <span>Send</span>
                        </button>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div>
                      <MdEmail
                        style={{ fontSize: "40px"}}
                      />
                    </div>
                    <div>
                      <h3 style={{ fontWeight: "800", fontSize: "25px" }}>
                        Email
                      </h3>
                      <h4 style={{ fontWeight: "400", fontSize: "19px" }}>
                        kushanandarawewa1@gmail.com
                      </h4>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div>
                      <FaPhoneAlt
                        style={{ fontSize: "40px"}}
                      />
                    </div>
                    <div>
                      <h3 style={{ fontWeight: "800", fontSize: "25px" }}>
                        Phone
                      </h3>
                      <h4 style={{ fontWeight: "400", fontSize: "19px" }}>
                        +94 714249784
                      </h4>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "20px" }}>
                    <div>
                      <FaLocationDot
                        style={{ fontSize: "40px" }}
                      />
                    </div>
                    <div>
                      <h3 style={{ fontWeight: "800", fontSize: "25px" }}>
                        Address
                      </h3>
                      <h4 style={{ fontWeight: "400", fontSize: "19px" }}>
                        105,Nisshanka Mawatha,
                      </h4>
                      <h4 style={{ fontWeight: "400", fontSize: "19px" }}>
                        Malkaduwawa,
                      </h4>
                      <h4 style={{ fontWeight: "400", fontSize: "19px" }}>
                        Kurunegala
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "20px" }}>
                <div className="social-icon">
                  <a
                    href={myData[0]?.data.githubLink}
                    target="_blank"
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s ",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#A673D1";
                      e.currentTarget.querySelector("svg").style.color =
                        "white";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                      e.currentTarget.querySelector("svg").style.color =
                        "#A673D1";
                    }}
                  >
                    <FaGithub style={{ fontSize: "2rem", color: "#A673D1" }} />
                  </a>
                  <a
                    href={myData[0]?.data.linkedinLink}
                    target="_blank"
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#A673D1";
                      e.currentTarget.querySelector("svg").style.color =
                        "white";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                      e.currentTarget.querySelector("svg").style.color =
                        "#A673D1";
                    }}
                  >
                    <FaLinkedin
                      style={{ fontSize: "2rem", color: "#A673D1" }}
                    />
                  </a>
                  <a
                    href={myData[0]?.data.facebookLink}
                    target="_blank"
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#A673D1";
                      e.currentTarget.querySelector("svg").style.color =
                        "white";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                      e.currentTarget.querySelector("svg").style.color =
                        "#A673D1";
                    }}
                  >
                    <FaFacebook
                      style={{ fontSize: "2rem", color: "#A673D1" }}
                    />
                  </a>
                  <a
                    href={myData[0]?.data.whatsappNo}
                    target="_blank"
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s ease-in-out",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#A673D1";
                      e.currentTarget.querySelector("svg").style.color =
                        "white";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                      e.currentTarget.querySelector("svg").style.color =
                        "#A673D1";
                    }}
                  >
                    <IoLogoWhatsapp
                      style={{ fontSize: "2rem", color: "#A673D1" }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
